module.exports = __webpack_public_path__ + "img/52.e7e2b1a8.svg";